
import {Component, Input, ViewEncapsulation} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { PeriodicityType } from '@gnv-shared/models';
import {MatRadioButton, MatRadioGroup} from '@angular/material/radio';

@Component({
  selector: 'app-periodicity-type',
  templateUrl: './periodicity-type.component.html',
  styleUrls: ['./periodicity-type.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatRadioGroup,
    MatRadioButton
]
})
export class PeriodicityTypeComponent {
  @Input() valueFormControl = new FormControl<PeriodicityType>(PeriodicityType.DATE);

  public values = PeriodicityType;

}
